import { useRouter } from "next/router";
import { classNames } from "primereact/utils";
import { Location } from "../../../../../common/models";
import { Company } from "../../../../users/models/company.model";

interface ValueTemplateProps {
    companies: Company[];
}

const getDisplayName = (
    company: Company | undefined,
    location: Location | undefined,
    locationId: string | undefined
) => {
    if (!company) return "-";
    if (locationId) return location?.name || "-";
    return company.name || "-";
};

const ValueTemplate = (props: ValueTemplateProps) => {
    const { companies } = props;

    const router = useRouter();
    const { companyId, locationId } = router.query as {
        companyId?: string;
        locationId?: string;
    };

    const company = companies.find((company) => company.id === companyId);
    const location = company?.locations?.find(
        (location) => location.id === locationId
    );

    return (
        <div className="flex items-center gap-1.5 text-primary-text">
            <i
                className={classNames(
                    "pi text-base",
                    locationId ? "pi-map-marker" : "pi-building"
                )}
            />
            <span className="truncate">
                {getDisplayName(company, location, locationId)}
            </span>
        </div>
    );
};

export default ValueTemplate;
